import React from 'react';
import { type Control, useFieldArray } from 'react-hook-form';

import { ReactComponent as RemoveIcon } from '@assets/svg/ic-remove.svg';

import Input from '@components/uikit/Input/Input';

import useTranslation from '@hooks/useTranslation';

import { COMPLETION_REPORT_FIELDS } from '../constants/schemaCompletionReport';
import style from './style.module.scss';

const emptyPart = { nameOfOem: '', amazonPart: '', amazonEamPart: '' };

interface IProps {
  control: Control
}

const StepReplacementInfo: React.FC<IProps> = ({ control }) => {
  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({
    name: COMPLETION_REPORT_FIELDS.REPLACED_PARTS,
    control,
  });

  return (
    <div className={style.stepReplacementInfo}>
      {fields.map((part, i) => (
        <div key={`part-${i}`} className={style.partsItem}>
          <Input
            name={`${COMPLETION_REPORT_FIELDS.REPLACED_PARTS}[${i}][nameOfOem]`}
            control={control}
            label={t(i === 0 ? 'Name of OEM' : '')}
          />
          <Input
            name={`${COMPLETION_REPORT_FIELDS.REPLACED_PARTS}[${i}][amazonPart]`}
            control={control}
            label={t(i === 0 ? 'Part number' : '')}
          />
          <Input
            name={`${COMPLETION_REPORT_FIELDS.REPLACED_PARTS}[${i}][amazonEamPart]`}
            control={control}
            label={t(i === 0 ? 'Supplier part number' : '')}
          />
          {fields.length > 1 && <RemoveIcon className={style.removePartIcon} onClick={() => remove(i)} />}
        </div>
      ))}
      <div className={style.separator} />
      <div className={style.addMoreBtnWrapper}>
        <span className={style.addMoreBtn} onClick={() => append(emptyPart)}>
          + {t('Add more placed parts')}
        </span>
      </div>
    </div>
  );
};

export default StepReplacementInfo;
